import React, { Component } from 'react'

//other components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CustomButton from "../buttons/CustomButton";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Growl } from 'primereact/growl';

//generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";

import {
    openCariModal,
    resetCariActiveData,
    setCariActiveUserData
} from "../../../redux/actions/indexActions";

import { connect } from "react-redux";

//router
import {
    withRouter,
} from 'react-router-dom';


//constants
const DEFAULTMAXFILESIZE = 20000000;
const MAX_FILE_NAME_CHARACTER_LENGTH = 20;

//redux mapper
const mapStateToProps = state => {
    return {
        activeApplicationData: state.cariReducer.activeApplicationData,
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData
    };
};
const mapDispatchToProps = dispatch => {

    return {
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
        setCariActiveUserData: (user_data) => {
            dispatch(setCariActiveUserData(user_data))
        },
    };
};

/*
    props: 
        className => to format
        name => unique name of input, ie: cover_letter_0
        maxFileSize => max size in bytes for this input file
        showMaxFileSize => true/false shows or hides max file size
        placeholder => placeholder text of file box
        defaultValue => the set value of the dropdown
        required => true/false sets the required field for input text
        disabled => true/false disabling box
        enableDeleteMode => true/false for showing the X button instead of replacment button, if replacement, auto open file upload to replace files, if X button, delete file, reset format

        file => {fileName: "", fileSize: 100, app_docs_id: 5} set file value
        acceptedFileTypes => the types of files this file input accepts in the format of : ".doc, .docx, .pdf"
        emptyFileBoxClassName => classname styling of the empty file box

        onChangeSetParentState => function on change to call set parent state or grab data from api after upload: parameters: value, nameKey// unique name key, groupName// name of file group

        uploadBySubmit => true/false, if false, will upload immediately based on the link, if true, the upload will occur elsewhere and the file will be set to the parent from the onChangeSetParent function

        onFileUpload => call back function to handle file upload
        onFileDelete => call back function to handle file deletion
        onFileReplaceUpload => call back function to handle file replace upload

        doc_type => ""
*/


class SingleUploadFileBox extends Component {

    state = {
        mounted: false,
        fileUploadingStatus: false, //true/false if file is uploading
        focused: false,
        tempFileDisplayData: {
            fileName: "",
            fileSize: "",
        }
    }

    constructor(Props) {
        super(Props);

        //refs
        this.toastRef = React.createRef();

        //handlers for delete or replace or select for upload
        this.handleFileDelete = this.handleFileDelete.bind(this);
        this.handleFileReplace = this.handleFileReplace.bind(this);
        this.handleFileSelect = this.handleFileSelect.bind(this);

        //handeler for update the comments of the file
        this.handleSaveAddCommentsToDocsUploadedModal = this.handleSaveAddCommentsToDocsUploadedModal.bind(this);

        //action handlers
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnFocus = this.handleOnBlur.bind(this);

        //building button
        this.getDeleteBtn = this.getDeleteBtn.bind(this);
        this.getReplaceBtn = this.getReplaceBtn.bind(this);
        this.getUploadingIcon = this.getUploadingIcon.bind(this);

        //rendering action buttons
        this.renderActionBtnCol = this.renderActionBtnCol.bind(this);
        this.renderFileSize = this.renderFileSize.bind(this);
        this.renderFileText = this.renderFileText.bind(this);

        //rendering UI
        this.renderEmptyBorderClass = this.renderEmptyBorderClass.bind(this);

        //helper functions
        this.clearSelectedFile = this.clearSelectedFile.bind(this);
        this.convertFileSizeToReadableFormat = this.convertFileSizeToReadableFormat.bind(this);
        this.convertFileToSmallName = this.convertFileToSmallName.bind(this);
    }

    clearSelectedFile() {
        //CLEAR input file box
        this.fileInput.value = null;

        //clear the file display data
        var emptyTempFileDisplayData = {
            fileName: "",
            fileSize: "",
        }

        //clear previous value for uploading status 
        this.setState({
            fileUploadingStatus: false,
            tempFileDisplayData: emptyTempFileDisplayData,
        });
    }

    convertFileSizeToReadableFormat(fileSizeBytes) { 
        //set to 2 decimal placesfor MB
        var fileSizeMB = ((fileSizeBytes / 1024) / 1024).toFixed(2);
        return fileSizeMB + " MB";
    }

    /*
        convert file name to maximum 20 characters
        5 3 5 .docx .docs .pdf
    */
    convertFileToSmallName(fullFileName) {
        
        if (fullFileName.length > MAX_FILE_NAME_CHARACTER_LENGTH) {
            //split the file name based on the last . for extension
            var fileNamePartArr = fullFileName.split("."); // split by .

            //grab the last part to get file extension
            var fileExt = fileNamePartArr[fileNamePartArr.length - 1];

            //combine the rest of the file name back without the extension
            var fileNameWithoutExt = "";
            for (var i = 0; i < fileNamePartArr.length - 1; i++) {
                fileNameWithoutExt = fileNamePartArr[i];
            }

            //get the first 10 character of the file name and last 5 characters of the file name
            var first10CharFileName = fileNameWithoutExt.slice(0, 10);
            var last5CharFileName = fileNameWithoutExt.slice(fileNameWithoutExt.length - 5, fileNameWithoutExt.length);
            //build the string
            var minimizedFileName = first10CharFileName + "..." + last5CharFileName + "." + fileExt;

            return minimizedFileName;
        }
        else {
           //return file name
           return fullFileName;
        }
    }

    handleFileSelect = (event) => {
        //gurantees the files is not undefined
        if (!isEmpty(event.target.files[0])) {

            //set the file name and fileSize;
            var selectedFileSize = event.target.files[0].size;
            var selectedFileName = event.target.files[0].name;

            //check if the file size is under the limit
            if (selectedFileSize < this.props.maxFileSize) {

                var fileToUpload = event.target.files[0];

                 //if upload immediately
                if (!this.props.uploadBySubmit) {
                    //setup file uploading status and file name and file display name
                    var tempFileDisplayData = {
                        fileName: selectedFileName,
                        fileSize: selectedFileSize,
                    }
                    this.setState({
                        fileUploadingStatus: true,
                        tempFileDisplayData: tempFileDisplayData,
                    });

                    var fileUploadObj = null;

                    //if not upload by submit, upload file
                    if (!this.props.uploadBySubmit) {

                        //if app docs id exist, replace upload file
                        if (!isEmpty(this.props.file)
                            && (!isEmpty(this.props.file.app_docs_id))
                        ) {
                            fileUploadObj = {
                                file: fileToUpload,
                                doc_type: this.props.doc_type,
                                replace_app_docs_id: this.props.file.app_docs_id,
                            }

                            // api call to upload
                            if (!isEmpty(this.props.onFileReplaceUpload)) {
                                this.props.onFileReplaceUpload(fileUploadObj, (app_docs_id, parentCallBackFunc) => {
                                    if (this.state.mounted) {
                                        //set fileUploading status to false and clear data
                                        this.clearSelectedFile();
                                    }
                                });
                            }
                            //since it failed to upload, clear display data and the file input
                            else {
                                if (this.state.mounted) {
                                    //set fileUploading status to false and clear data
                                    this.clearSelectedFile();
                                }
                            }
                        }
                        //do a normal file upload
                        else {
                            fileUploadObj = {
                                file: fileToUpload,
                                doc_type: this.props.doc_type
                            }
                            // api call to upload
                            if (!isEmpty(this.props.onFileUpload)) {
                                this.props.onFileUpload(fileUploadObj, (app_docs_id, parentCallBackFunc) => {
                                    if (this.state.mounted) {
                                        //set fileUploading status to false and clear data
                                        this.clearSelectedFile();
                                    }
                                });
                            }
                            //since it failed to upload, clear display data and the file input
                            else {
                                if (this.state.mounted) {
                                    //set fileUploading status to false and clear data
                                    this.clearSelectedFile();
                                }
                            }
                        }
                    }
                }

                //saved locally, then post data on submit
                else {
                    //add file if loaded file is empty and adding a new file
                    if(isEmpty(this.props.file)) {
                        let fileObj = {
                            file: fileToUpload,
                            doc_type: this.props.doc_type,
                            fileName: selectedFileName,
                            fileSize: selectedFileSize,
                            nameKey: this.props.name
                        }

                        if (!isEmpty(this.props.onChangeSetParentState)) {
                            if (this.state.mounted) {
                                //set fileUploading status to false and clear data
                                this.clearSelectedFile();
                            }
                            this.props.onChangeSetParentState(fileObj, this.props.name, "add");

                            //display toast
                            this.toastRef.current.show({ life: 6000, severity: 'success', summary: 'Added file to upload queue', detail: "" });
                        }
                    }
                    //replace the file if loaded file is not empty and delete mode is false
                    else if (!isEmpty(this.props.file) && !this.props.enableDeleteMode) {
                        let fileObj = {
                            file: fileToUpload,
                            doc_type: this.props.doc_type,
                            fileName: selectedFileName,
                            fileSize: selectedFileSize,
                            nameKey: this.props.name
                        }

                        if (!isEmpty(this.props.onChangeSetParentState)) {
                            if (this.state.mounted) {
                                //set fileUploading status to false and clear data
                                this.clearSelectedFile();
                            }
                            this.props.onChangeSetParentState(fileObj, this.props.name, "replace");

                            //display toast
                            this.toastRef.current.show({ life: 6000, severity: 'success', summary: 'Replaced file in upload queue', detail: "" });
                        }
                    }
                }
            }
            //file too large, send out a growl, reset file size
            else {
                this.toastRef.current.show({ life: 6000, severity: 'error', summary: 'File size is too large', detail: "" });

                if (this.state.mounted) {
                    this.clearSelectedFile();
                }
            }
        }
    }

    handleFileDelete() {
        //if uploadBySubmit true, delete file locally upon click
        if(this.props.uploadBySubmit) {
            if (!isEmpty(this.props.onChangeSetParentState)) {
                let fileObj = {
                    doc_type: this.props.doc_type,
                    app_docs_id: this.props.file.app_docs_id,
                    fileName: this.props.file.fileName,
                    fileSize: this.props.file.fileSize,
                }
                this.props.onChangeSetParentState(fileObj, this.props.name, this.props.groupName);
            }

            this.toastRef.current.show({ life: 6000, severity: 'success', summary: "Deleted File!", detail: "" });

            //clear the file and reset it to empty state
            if (this.state.mounted) {
                this.clearSelectedFile();
            }

            //remove this file upload if it is not the last item
            this.props.onClickDeleteFile(this.props.name);
        }
        //if uploadBySubmit false, send api call to delete file
        else {
            var app_docs_id = this.props.file.app_docs_id;

            //api call to delete file, and it will do refresh of page
            if (!isEmpty(this.props.onFileDelete)) {
                this.props.onFileDelete(app_docs_id, (fileDeleted, parentCallBackFunc) => {
                    // //only set if mounted
                    if (fileDeleted) {
                        this.toastRef.current.show({ life: 6000, severity: 'success', summary: "Deleted File!", detail: "" });

                        if (this.state.mounted) {
                            //clear the file and reset it to empty state
                            this.clearSelectedFile();

                            //call back to refresh page
                            parentCallBackFunc();
                        }
                    }
                    else {
                        //display toast
                        this.toastRef.current.show({ life: 6000, severity: 'error', summary: 'Failed to upload the file', detail: "" });

                        //clear the file and reset it to empty state
                        if (this.state.mounted) {
                            this.clearSelectedFile();
                        }
                    }
                });
            }
        }
    }

    handleSaveAddCommentsToDocsUploadedModal() {
        var app_docs_id = this.props.file.app_docs_id;
        var comments = this.props.file.note;
     
        //popup a modal
        this.props.openCariModal({
            modalId: "addCommentsToDocsUploadedModal",
            title: "Comment",
            contentText: "Optional: Provide a comment for this document that will be displayed to the reviewer as they view your application attachments.",
            note: this.props.file.note,
            callBackFuncOnOk: (data) => {
                var comments = data;
            
                //api call to save note, and it will do refresh of page
                if (!isEmpty(this.props.onSaveAddCommentsToDocsUploadedModal)) {
                    this.props.onSaveAddCommentsToDocsUploadedModal(app_docs_id, comments, (commentsUpdated, parentCallBackFunc) => {
                        // //only set if mounted
                        if (commentsUpdated) {
                            this.toastRef.current.show({ life: 6000, severity: 'success', summary: "Comment Updated", detail: "" });

                            if (this.state.mounted) {
                                //clear the file and reset it to empty state
                                this.clearSelectedFile();

                                //call back to refresh page
                                parentCallBackFunc();
                            }
                        }
                        else {
                            //display toast
                            this.toastRef.current.show({ life: 6000, severity: 'error', summary: 'Failed to update comment', detail: "" });

                            //clear the file and reset it to empty state
                            if (this.state.mounted) {
                                this.clearSelectedFile();
                            }
                        }
                    });
                }
            }
        });
    }

    

    handleFileReplace() {
        //click replace file handler
        this.fileInput.click();
    }

    handleOnBlur() {
        //on blur, set focused to false
        this.setState({
            focused: false,
        });
    }

    handleOnFocus() {
        //if on focus, sets focused flag to true
        this.setState({
            focused: true,
        });
    }

    getDeleteBtn() {
        return (
            <span>
                <CustomButton
                    icon={"times"}
                    iconSize={"sm"}
                    className={"p-button-danger replace_btn_border_round"}
                    btnRound={true}
                    btnRaised={true}
                    onClickSetParentState={(event) => this.handleFileDelete()}
                />
            </span>
        );
    }

    getReplaceBtn() {
        return (
            <span>
                <CustomButton
                    label={"Replace"}
                    className={"p-button-warning replace_btn_border_round"}
                    textOnly={true}
                    btnRound={true}
                    btnRaised={true}
                    onClickSetParentState={(event) => this.handleFileReplace()}
                />
            </span>
        );
    }

    getUploadingIcon() {
        return (
            <span className="uploading_icon_format">
                <ProgressSpinner className={"uploading_icon_size"} strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
            </span>
        );
    }

    //renders the button either spinner/replace/x
    renderActionBtnCol() {
 
        //if spinner is set to true, display it
        if(this.state.fileUploadingStatus) {
            return this.getUploadingIcon();
        }
        else {
            //if enable delete mode is active:
            if (!isEmpty(this.props.enableDeleteMode)
             && this.props.enableDeleteMode) {
                return this.getDeleteBtn();
            }
            else {
                return this.getReplaceBtn();
            }
        }
    }

    //render for required tags
    renderEmptyBorderClass() {
        //if not disabled, required, not focused and the current file is empty, return the empty border class
        if (!this.props.disabled
            && this.props.required
            && isEmpty(this.props.file)
            && !this.state.focused
        ) {
            return "react_select_empty_border";
        }
        else {
            return "";
        }
    }

    //render file name display
    renderFileText() {
        if (!this.state.fileUploadingStatus
            && !isEmpty(this.props.file)
            && !isEmpty(this.props.file.fileName)) {
            return this.convertFileToSmallName(this.props.file.fileName);
        }
        else {
            return this.convertFileToSmallName(this.state.tempFileDisplayData.fileName);
        }
    }

    //render file upload date display
    renderFileUploadDate() {
        if (!isEmpty(this.props.file)
            && !isEmpty(this.props.file.uploadDate)) {
            return this.props.file.uploadDate;
        }
        else {
            return "";
        }
    }

    //render file size display and if file is uploading, do not display file size
    renderFileSize() {
        if (!isEmpty(this.props.file)
            && !isEmpty(this.props.file.fileSize)) {
            return this.convertFileSizeToReadableFormat(this.props.file.fileSize);
        }
        else {
            //return this.convertFileSizeToReadableFormat(this.state.tempFileDisplayData.fileSize);
            return "";
        }
    }

    componentDidMount() {
        this.setState({
            mounted: true
        });
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    render() { 
        return (
            <div className="align_file_input_text">
                <Growl 
                    ref={this.toastRef}
                    baseZIndex={9000}
                    position={"topright"}
                />
                <div 
                    className={"uploaded_file_state " + 
                        (this.state.fileUploadingStatus || (!isEmpty(this.props.file)) 
                    ? "" 
                    : "display_none") }>
                    <div className="p-grid">
                        <div className="p-col-4 file_padding_top">
                            <span className="file_name pull_left file_upload_text_padding word_wrap">
                                {this.renderFileText()}
                            </span>
                        </div>
                        <div className="p-col-3 file_padding_top">
                            <span className="file_size pull_left file_upload_text_padding word_wrap">
                                {this.renderFileUploadDate()}
                            </span>
                        </div>
                        <div className="p-col-2 file_padding_top">
                            <span className="file_size pull_left file_upload_text_padding word_wrap">
                                {this.renderFileSize()}
                            </span>
                        </div>
                        <div className="p-col-2 file_btn_padding">
                            <span className="pull_right">
                                {this.renderActionBtnCol()}
                            </span>
                        </div>
                        
                        {this.props.displayComment == true ? 
                            <div className="p-col-1 comment_btn_padding">
                                <FontAwesomeIcon
                                    icon="comment"
                                    size="lg"
                                    className={"no_comments_icon_style " + (!isEmpty(this.props.note) ? "comments_icon_style" : "")}
                                    onClick={(event) => this.handleSaveAddCommentsToDocsUploadedModal()}
                                />
                            </div>
                        : null}
                    </div>
                </div>
              
                <div 
                    className={"empty_file_state " + 
                    (!this.state.fileUploadingStatus &&
                        (isEmpty(this.props.file))
                    ? "" 
                    : "display_none") } 
                >    
                    {(!isEmpty(this.props.showMaxFileSize) ? this.props.showMaxFileSize : false) ? 
                        <strong className="file_upload_detail_small_label">
                            Max File Size: {(isEmpty(
                                this.props.file)
                                ? this.convertFileSizeToReadableFormat(this.props.file.fileSize) 
                                : this.convertFileSizeToReadableFormat(DEFAULTMAXFILESIZE
                            ))}
                        </strong>
                    : null}

                    <div className="p-grid">
                        <div className="p-col-1">
                            {/* empty space */}
                        </div>
                        <div className="p-col-10 no_padding_right">
                            <span 
                                className="p-calendar file_upload_placeholder_textbox_format "
                            >
                                <input 
                                    type="text"
                                    className={"p-inputtext p-component p-filled file_upload_placeholder_textbox_format " + this.renderEmptyBorderClass()}
                                    placeholder={(!isEmpty(this.props.placeholder) ? this.props.placeholder : "Select a File")}
                                    disabled={(!isEmpty(this.props.disabled) ? this.props.disabled : false)}
                                    readOnly={true}
                                    onBlur={(e) => this.handleOnBlur(e)}
                                    onFocus={(e) => this.handleOnFocus(e)}
                                    onClick={(event) => this.fileInput.click()}
                                    disabled={(!isEmpty(this.props.disabled) ? this.props.disabled : false)}
                                />
                                <button 
                                    type="button" 
                                    tabIndex="-1" 
                                    className="p-button p-component p-datepicker-trigger p-calendar-button p-button-icon-only file_icon_style"
                                    onClick={(event) => this.fileInput.click()}
                                    disabled={(!isEmpty(this.props.disabled) ? this.props.disabled : false)}
                                >
                                    <FontAwesomeIcon
                                        icon="file"
                                        size="sm"
                                    />
                                </button>
                            </span>
                        </div>
                        <div className="p-col-1">
                            {/* empty space */}
                        </div>
                    </div>
                        
                    <input 
                        ref={(ref) => this.fileInput = ref} 
                        type="file" 
                        name={this.props.name}
                        accept={this.props.acceptedFileTypes}
                        onChange={(event) => {
                            this.handleFileSelect(event)
                        }}
                        className="display_none"
                    />
                </div>
            </div>
        );
    }
}
// export default SingleUploadFileBox;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SingleUploadFileBox));